export const CANCELLATION_RULES = ({
  hotelId,
  roomId,
  dateFrom,
  dateTo
}: {
  hotelId: string;
  roomId: string;
  dateFrom: string;
  dateTo: string;
}) =>
  `${process.env["NEXT_PUBLIC_BASE_URL_HAPI"]}/internal/cancellation/admin/cancellations/rules?hotel_id=${hotelId}&room_id=${roomId}&date_from=${dateFrom}&date_to=${dateTo}`;
